import React from "react";
import { Link } from "react-router-dom";
import "../Modules/valueprop.css";
import { forwardRef } from "react";

const ValueProp = forwardRef((props, ref) => {
  return (
    <>
      <center ref={ref}> <br /><br />
        <h3 className="text-success">Unique Value Proposition</h3>
        <p style={{ borderBottom: "2px solid grey", width: "150px" }}></p>{" "}
        <br />
        
        <section className="container">
          <div id="demo" class="carousel slide" data-ride="carousel">
            {/* <!-- Indicators --> */}
            <ul class="carousel-indicators bg-dark">
              <li data-target="#demo" data-slide-to="0" class="active"></li>
              <li data-target="#demo" data-slide-to="1"></li>
              <li data-target="#demo" data-slide-to="2"></li>
            </ul>

            {/* <!-- The slideshow --> */}
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  class="d-block w-100 specimg"
                  src="img4.jpg"
                  alt="Neurocritical Care image"
                />
                <div class="carousel-caption opac" style={{color:'black'}}>
                  <h3 >Green Grow</h3>
                  <p>
                    Our own farming business that guarantees the freshest
                    produce sourced directly from our farms.
                  </p>
                </div>
              </div>

              <div class="carousel-item">
                <img
                  class="d-block w-100 specimg"
                  src="img2.jpg"
                  alt="Motility Center"
                />
                <div class="carousel-caption opac" style={{color:'black'}}>
                  <h3>Fresh Flow</h3>
                  <p>
                    {" "}
                    A robust logistics system that enhances the stock and
                    distribution process, ensuring timely and efficient delivery
                    of goods.
                  </p>
                </div>
              </div>

              <div class="carousel-item">
                <img
                  className="d-block w-100 specimg"
                  src="img3.jpg"
                  alt="Urology Center"
                />
                <div class="carousel-caption opac" style={{color:'black'}}>
                  <h3>Ojaami</h3>
                  <p>
                  Ojaami is the e-commerce branch of Food Supply Vision, designed to offer consumers an easy
                  and affordable way to shop for fresh, high-quality farm products.{" "}
                  </p>
                </div>
              </div>
            </div>

            {/* Left and right controls */}
            <a class="carousel-control-prev" href="#demo" data-slide="prev">
              <span class="carousel-control-prev-icon bg-dark"></span>
            </a>
            <a class="carousel-control-next" href="#demo" data-slide="next">
              <span class="carousel-control-next-icon bg-dark"></span>
            </a>
          </div>
        </section>{" "}
        <br />




        <section className="aboutSection" >
        <div className="container-fluid">
            <div className='innerOurMissionSection'>
            <h3 className='ourMissionHeading' style={{textAlign:'center'}}>Unique Value Proposition (UVP) of Food Supply Vision</h3> <br />
            <div style={{textAlign:'justify'}}>At Food Supply Vision, we make fresh, high-quality food accessible and affordable for everyone. By combining sustainable farming, easy online shopping, and reliable delivery, we ensure your groceries arrive fresh, fast, and worry-free. Through innovative features like VR shopping and real-time tracking, we bring the farm-to-table experience directly to your home, creating a food journey you can trust and enjoy.</div><br />
            <h4 className="text-success"> How We Stand Out </h4> <br />
            <div style={{textAlign:'justify'}}>
              <ul>
                <li><h5 style={{textAlign:'left'}}>End-to-End Control</h5> Food Supply Vision ensures superior quality and consistency by managing the entire supply chain—from cultivation at Green Grow to direct sales through Ojaami and efficient delivery via Fresh Flow.</li> <br />

                <li><h5 style={{textAlign:'left'}}>For Everyday Shoppers:</h5> We understand that you want fresh, affordable food without the hassle. That’s why Ojaami delivers straight to your door, saving you time and energy.</li> <br />

                <li><h5 style={{textAlign:'left'}}>Quality You Can Count On:</h5> Our farm, Green Grow, grows the food you love, so you can be confident it’s fresh, healthy, and handled with care.
                </li> <br />

                <li><h5 style={{textAlign:'left'}}>Peace of Mind:</h5> With our real-time tracking system (RTTMS), you’ll always know where your order is and when it will arrive.</li> <br />

                <li><h5 style={{textAlign:'left'}}>A Modern Shopping Experience:</h5>Experience the joy of grocery shopping from your couch with our upcoming VR platform—browse, pick, and explore your groceries as if you were there in person.
                </li> <br /> 

                <li><h5 style={{textAlign:'left'}}>Sustainability for the Future</h5>By growing and delivering your food responsibly, we’re building a better food system that cares for the planet as much as it cares for you.
                </li> <br /> 
              </ul>
             <p> Food Supply Vision isn’t just about delivering groceries; it’s about delivering trust, convenience, and the joy of knowing where your food comes from—all while making life a little easier for you and your family.
             </p>
            </div>
            </div>
          </div>
        </section>


        

        <section className='gainSection2' style={{backgroundColor:'rgb(25, 25, 25)'}}>
          <div className="container-fluid">
            <div className='innerOurMissionSection'>
                  <h2 className='ourMissionHeading'>Values</h2> <br />
                  <div className="mainBlueColor wow animate__animated animate__zoomIn leftTextAlign">
                    <ul>
                      <li><b>Freshness:</b> Ensuring the highest quality and freshness of produce.</li>
                      <li><b>Community:</b> Promoting eco-friendly practices in farming and packaging.</li>
                      <li><b>Sustainability:</b> Supporting local farmers and engaging with the community.</li>
                      <li>Innovation</li>
                    </ul>
                    </div> <br />
                  <div >
                    
                  </div> <br />
            </div>
          </div>
        </section>
      </center>
    </>
  );
});

export default ValueProp;
